import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {ProductBarcodeReportData} from "./product-barcode-report.data";

@Injectable()
export class ProductBarcodeReportModel extends ReportModel<ProductBarcodeReportData> {
    constructor(injector: Injector) {
        super(injector, ProductBarcodeReportData);
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
